export const HOME_SALE_SAVED_FAVORITE = require('../../assets/images/home-purchase-search-saved-favorites.png');

export const BUY_SAVE_SEARCH = require('../../assets/images/buy/save-search.png');

export const BUY_TOUR = require('../../assets/images/buy/tour.png');

export const BUY_OFFER = require('../../assets/images/buy/offer.png');

export const BUY_ATTACH_FILES = require('../../assets/images/buy/attach-files.png');

export const BUY_CHAT = require('../../assets/images/buy/chat.png');

export const HOMEOWNER = require('../../assets/images/home-ownership.png');

export const DEFAULT_AVATAR = require('./../../assets/images/default-avatar.png');

export const MILESTONES_LOGO = require('./../../assets/images/milestones-logo-color.svg');

export const SELL_IMAGES = {
    MAXIMIZE_SALE_PRICE: require('./../../assets/images/maximize-sale-price.png'),
    SELL_QUICK: require('./../../assets/images/sell-quick.png'),
    BUY_BEFORE_SELL: require('./../../assets/images/buy-before-sell.png'),
};

export const FINANCE_IMAGES = {
    SINGLE_LENDER_CARD_IMAGE: require('./../../assets/images/project_mortgage.svg'),
    DEFAULT_COMPANY_LOGO: require('./../../assets/images/default-company-logo.png'),
};

export const HOME_IMAGES = {
    DEFAULT_COVER: require('./../../assets/images/home_section_cover_crop.jpg'),
    POPOVER_CARD_COVER: require('./../../assets/images/popover_card_cover.jpg'),
    BUY: require('./../../assets/images/home-buy.png'),
    SELL: require('./../../assets/images/home-sell.png'),
    FINANCE: require('./../../assets/images/home-finance.png'),
    TRADE: require('./../../assets/images/buy-before-sell.png'),
    AGENT_AND_LOAN_OFFICER_COVER: require('./../../assets/images/home_section_cover_agent_loan_officer.jpg'),
    DEFAULT_BABY_MAIN_IMAGE: require('./../../assets/images/baby-or-adoption.png'),
    DEFAULT_BABY_BACKGROUND: require('./../../assets/images/default-baby-or-adoption-background.png'),
};

export const ONBOARDING_IMAGES = {
    LANDING_PAGE: require('./../../assets/images/onboarding/landing-page.png'),
    NURTURE: require('./../../assets/images/onboarding/nurture.png'),
    HUB: require('./../../assets/images/onboarding/hub.png'),
};

export const KNOWLEDGE_ASSET = {
    CARD_COVER: require('./../../assets/images/knowledgeAsset/knowledge_asset_card_cover_placeholder.jpg'),
    COVER: require('./../../assets/images/knowledgeAsset/knowledge_asset_cover_placeholder.jpg'),

};
